import type { ReactNode } from 'react';

import { TableCell, TableRow } from '@shigo-ui/ui';

export function DashboardDataTableMessage({
  columnCount,
  message,
}: {
  columnCount: number;
  message: ReactNode;
}) {
  return (
    <TableRow>
      <TableCell
        data-slot="dashboard-table-message"
        colSpan={columnCount}
        className="text-muted-foreground h-40 px-4 text-center text-[13px]"
      >
        {message}
      </TableCell>
    </TableRow>
  );
}
